import { createStore, applyMiddleware, combineReducers } from 'redux';
import { composeWithDevTools } from 'redux-devtools-extension/developmentOnly';
import createSagaMiddleware from 'redux-saga';

import { captchaReducer } from 'CorePackage/CaptchaModule/reducers/captchaReducer';
import { feedbackReducer } from 'FeedbackPackage/MainModule/reducers/feedbackReducer';
import { newsReducer } from 'NewsPackage/MainModule/reducers/newsReducer';
import { publicOpenDataReducer } from 'OpenDataPackage/MainModule/reducers/publicOpenDataReducer';
import { passportKnmReducer } from 'PassportKnmPackage/MainModule/reducers/passportKnmReducer';
import { searchReducer } from 'SearchPackage/MainModule/reducers/searchReducer';
import { systemInoperabilityReducer } from 'NewsPackage/MainModule/reducers/systemInoperabilityReducer';

import { coreReducer } from '../reducers/coreReducer';
import { rootSaga } from '../sagas/rootSaga';

const sagaMiddleware = createSagaMiddleware();

const rootReducer = combineReducers({
  search: searchReducer,
  captcha: captchaReducer,
  core: coreReducer,
  passportKnm: passportKnmReducer,
  feedback: feedbackReducer,
  news: newsReducer,
  systemInoperability: systemInoperabilityReducer,
  publicOpenData: publicOpenDataReducer,
});

export const store = createStore(rootReducer, composeWithDevTools(applyMiddleware(sagaMiddleware)));

sagaMiddleware.run(rootSaga);
